import teacher from "./teacher";
import media from "./media";

export default {
  namespaced: true,
  modules: {
    teacher: teacher,
    media: media,
  },
};
